import React, { useEffect, useState } from "react";
import axios from "axios";
import ENVIRONMENT from "../../../../environments";
import { Row, Modal, Button, Tabs, Col } from "antd";
import * as Utilities from "../../Utilities";
import DottedLoader from "../../DottedLoader/DottedLoader";
import SceneList from "./SceneList";
import FileConstants from "../../../../FileConstants";

const { TabPane } = Tabs;
const COMPANY_ID = FileConstants.COMPANY_ID;
const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;

const RenderSceneSelect = (props) => {
  const {
    scene_id,
    isRenderModal,
    setIsRenderModal,
    selectedScenes,
    setSelectedScene,
    onConfirm,
    room_part
  } = props;
  const [tabActiveKey, setTabActiveKey] = useState("");
  const [selected, setSelected] = useState(selectedScenes || []);
  const [dataLoading, setDataLoading] = useState(false);
  const [scenes, setScenes] = useState({});
  const [tabs, setTabs] = useState([]);

  const handleSetSelected = (newSelected) => {
    if (newSelected.length > selected.length) {
      const addedId = newSelected.find(id => !selected.includes(id));
      
      let tabOfNewSelection = null;
      for (const [roomPartKey, scenesInTab] of Object.entries(scenes)) {
        if (scenesInTab.some(scene => scene.id === addedId)) {
          tabOfNewSelection = roomPartKey;
          break;
        }
      }
      
      if (tabOfNewSelection) {
        const scenesInSameTab = scenes[tabOfNewSelection].map(s => s.id);
        const filteredSelected = selected.filter(id => !scenesInSameTab.includes(id));
        setSelected([...filteredSelected, addedId]);
      } else {
        setSelected(newSelected);
      }
    } else {
      setSelected(newSelected);
    }
  };

  const groupDataByRoomPart = (data) => {
    const grouped = {};
    
    data.forEach(item => {
      const roomPart = item.room_part;
      
      if (!roomPart || roomPart.trim() === '' || !item.scene_config_id) {
        return;
      }
      
      if (room_part && roomPart.toLowerCase() === room_part.toLowerCase()) {
        return;
      }
      
      if (!grouped[roomPart]) {
        grouped[roomPart] = [];
      }
  
      item.id = item.scene_config_id;
      item.name = item.scene_name;
      
      grouped[roomPart].push(item);
    });
    
    return grouped;
  }

  const getScenesData = async () => {
    setDataLoading(true);
    let payload = {
      scene_id: scene_id,
      customer_username: CUSTOMER_USERNAME,
      company_id : COMPANY_ID
    }
    await axios
      .post(ENVIRONMENT.GET_ROOM_PART_SCENES, payload)
      .then((res) => {
        if (res.data) {
          const groupedData = groupDataByRoomPart(res.data.body || res.data);
          setScenes(groupedData);
          
          const roomParts = Object.keys(groupedData);
          const tabsData = roomParts.map(roomPart => ({
            key: roomPart,
            type: "scene",
            title: roomPart.charAt(0).toUpperCase() + roomPart.slice(1), // Capitalize first letter
            data: groupedData[roomPart],
            selectable: true,
          }));
          
          setTabs(tabsData);
          
          // Set the first tab as active if tabs exist
          if (tabsData.length > 0) {
            setTabActiveKey(tabsData[0].key);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching variants:", error);
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleSubmit = async () => {
    if (setSelectedScene) {
      setSelectedScene(selected);
    }
    handleCancelSceneModal();
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancelSceneModal = () => {
    if (setIsRenderModal) {
      setIsRenderModal(false);
    }
    setSelected([]);
  };

  const handleTabChange = (key) => {
    setTabActiveKey(key);
  };

  useEffect(() => {
    if (scene_id && room_part) {
      setSelected(selectedScenes || []);
      getScenesData();
    }
  }, [scene_id, room_part]);

  return (
    <Modal
      destroyOnClose={true}
      closable={true}
      onCancel={handleCancelSceneModal}
      className="swap-modal"
      bodyStyle={{ padding: 0 }}
      footer={null}
      visible={!!isRenderModal}
    >
      <Row className="header-container">
        <div className="swap-heading-tag reset-heading-tag">
          <span className="manrope f-14">Select Scenes</span>
        </div>
      </Row>
      <Row className="justify-space-between swap-container">
        <Col span={16} className="justify-in-start">
          <span className="manrope f-20 w-600">
            Choose scene design(s) from other room parts to include in your render
            <span className="manrope f-14" style={{ marginLeft: 8, color: "#888" }}>
              ({selected.length} selected)
            </span>
          </span>
        </Col>
      </Row>
      <div className="swap-container">
        {tabs && tabs.length > 0 ? (
          <Tabs
            onChange={(key) => handleTabChange(key)}
            className="product-tab library"
            tabBarGutter={16}
            size="large"
            activeKey={tabActiveKey}
          >
            {tabs.map((tab, index) => {
              return (
                <TabPane
                  tab={tab.title}
                  key={tab.key}
                  style={{ padding: "0px 10px" }}
                >
                  {dataLoading ? (
                    <div className="modal-tab">
                      <DottedLoader />
                    </div>
                  ) : tab.data && tab.data.length > 0 ? (
                    <div className="product-tab library">
                      <SceneList
                        data={tab.data}
                        selectable={tab.selectable}
                        store={tab.store}
                        selected={selected}
                        setSelected={handleSetSelected}
                        setSelectedElementDetials={()=>{}}
                        product_id={undefined}
                        loader={tab.loader}
                        requestStatusProduct={''}
                      />
                    </div>
                  ) : (
                    <div className="modal-tab" style={{ minHeight: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span className="manrope f-14 grey-77">No scenes to display</span>
                    </div>
                  )}
                </TabPane>
              );
            })}
          </Tabs>
        ) : (
          <div className="modal-tab" style={{ minHeight: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="manrope f-14 grey-77">No other room parts available</span>
          </div>
        )}
      </div>
      <Row className="swap-modal-footer justify-in-end" onClick={() => {}}>
        <Button
          style={{ marginRight: 10 }}
          className="outline-red-btn square font-12 manrope"
          onClick={handleCancelSceneModal}
        >
          Cancel
        </Button>
        <Button
          className="modal-okay square font-14"
          onClick={handleSubmit}
        >
          {`Request Render${selected.length ? ` (${selected.length} selected)` : ""}`}
        </Button>
      </Row>
    </Modal>
  );
};

export default RenderSceneSelect;
